import { TextField } from "@material-ui/core"
import axios from "axios"
import { graphql, useStaticQuery } from "gatsby"
import React, { useState } from "react"
import useForm from "react-hook-form"
import InputRound from "../../../components/atoms/input-round/input-round"
import LayoutModal from "../../../components/organisms/layoutModal/layout-modal"
import useBrowserMode from "../../../hooks/useBrowserMode"
import useHomeLinkMode from "../../../hooks/useHomeLinkMode"
import useLocaleMode from "../../../hooks/useLocaleMode"
import AuthService from "../../../services/authentication"
import ProfileService from "../../../services/profile"
import { RECOVERY_EMAIL } from '../../../state/constants/apiConstants'
import { localStorage } from "../../../state/utils/storage"
import "./modal-auth.scss"

const ModalAuth = ({ hideAction, title, fromBenefits, validateCoverage, showModalCoverage }) => {

  const labelCorreo = "¿Cuál es tu correo electrónico?";
  const labelPassword = "Digite la contraseña";
  const labelCellPhone = "¿Cuál es tu celular?";
  const { handleSubmit, register, errors } = useForm();
  const [emailValid, setEmailValid] = useState(false);
  const [cellPhoneActive, setCellPhoneActive] = useState(false);
  const [cellPhoneValue, setCellPhoneValue] = useState();
  const [cellPhoneSend, setCellPhonSend] = useState(false);
  const [cellPhoneSendError, setCellPhonSendError] = useState(null);
  const [messageError, setMessageError] = useState(null);
  const { homeLink } = useHomeLinkMode();
  const { locale } = useLocaleMode();
  const [passswordStatus, setPasswordStatus] = React.useState(false);
  const { isBrowser } = useBrowserMode();

  const result = useStaticQuery(
    graphql`
      query SelectorPaisesPrefix {
        allContentfulTenaPaises(sort: {fields: orden, order: ASC}, filter: {node_locale: {eq: "es-CO"}}) {
          nodes {
            prefijoTelefonico
            codigoDeDosLetras
          }
        }
      }
    `
  );

  const filteredCountry = result && isBrowser &&
    result.allContentfulTenaPaises.nodes.filter(country => locale.includes(country.codigoDeDosLetras));
  const countryPrefix = filteredCountry[0].prefijoTelefonico

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  const navigateToRegister = () => window.location.href = homeLink + 'registro';
  const actionEmail = values => {
    const email = values.input;
    if (email) {
      const payload = {
        email: email,
        captcha: "1212",
      };
      ProfileService.validateEmail(
        payload,
        resdata => {
          const { data } = resdata;
          if (data.status === 200) {
            setMessageError(null);
            setEmailValid(email)

          } else if (data.status === 400) {
            setMessageError(data.userMessage)
          }
        },
        setMessageError
      )
    }
  };

  const handleSendCellPhone = () => {
    if (cellPhoneValue) {
      const payload = {
        cellPhone: `${countryPrefix}${cellPhoneValue}`
      };
      axios.post(RECOVERY_EMAIL, payload).then(restData => {
        const { data } = restData;
        if (data.status === 200) {
          setCellPhonSend(true);
          setCellPhoneValue("");
        }
        else if (data.status === 400 || data.status === 500) {
          setCellPhonSendError(data.userMessage);
        }
      }).catch(err => {
        console.log(err);
      })
    }
  }

  const actionPassword = values => {
    const password = values.password;
    const payload = {
      email: emailValid,
      password: password,
      captcha: "1212",
    };
    ProfileService.authLogin(payload, restData => {
      const { data } = restData;
      const authData = data.data;
      if (data.status === 200) {
        AuthService.userInfo(
          payload.email,
          authData.tokenData.idToken
        ).then((resp) => {
          if (resp.status === 200) {
            const userData = resp.data;
            localStorage.setItem("tokenData", authData.tokenData);
            localStorage.setItem(
              "userName",
              `${userData.name} ${userData.lastName}`
            );
            localStorage.setItem("userData", userData);
            sessionStorage.removeItem("tokenData");
            sessionStorage.removeItem("userName");
            sessionStorage.removeItem("userData");
            if (validateCoverage() === false) {
              hideAction();
              showModalCoverage()
            } else {
              fromBenefits
                ? (window.location.href = homeLink + "beneficios/acumula-puntos/")
                : (locale === "es-CO" ? (window.location.href = "muestra-gratis/confirmacion") : (window.location.href = "pide-tu-muestra/confirmacion"))
            }
          }
        })
      } else if (data.status === 400) {
        setMessageError(data.userMessage);
        setEmailValid(null);
      }
    })
  };

  return (
    <LayoutModal onClose={hideAction}>
      <form
        className="f-modal-auth"
        onSubmit={handleSubmit(emailValid ? actionPassword : actionEmail)}
      >
        <div className="f-card-modal-head">
          <span className="f-card-modal-head-icon" onClick={hideAction}>
            X
          </span>
        </div>
        <h3 className="f-modal-auth-title">
          {title !== undefined && title !== null
            ? title
            : "Para solicitar la muestra gratis, debes ingresar a tu cuenta en nuestro sitio Web"}
        </h3>
        {!emailValid && (
          <InputRound
            register={register({
              required: "Por favor digite su correo",
              pattern: {
                value: /^\S+@\S+$/i,
                message: "Email inválido",
              },
            })}
            name={"input"}
            type={"text"}
            placeholder={labelCorreo}
            errors={errors}
            messageError={messageError}
            resetError={() => setMessageError(null)}
          />
        )}
        {emailValid && (
          <InputRound
            register={register({
              required: "Por favor digite su contraseña",
              minLength: 6,
            })}
            name={"password"}
            type={passswordStatus ? "text" : "password"}
            placeholder={labelPassword}
            errors={errors}
            messageError={messageError}
            resetError={() => setMessageError(null)}
            edgeStatus={passswordStatus}
            setPasswordStatus={setPasswordStatus}
          />
        )}
        <div className="f-modal-auth-field">
          <span className="f-modal-auth-field-forget" onClick={() => setCellPhoneActive(true)}>
            ¿Olvidaste tu correo electrónico?
          </span>
          <button
            type="submit"
            className="f-modal-auth-field-button"
            disabled={errors[emailValid ? "password" : "input"]}
          >
            {!emailValid ? "SIGUIENTE" : "INGRESAR"}
          </button>
        </div>
        <div className={cellPhoneActive ? "f-modal-auth-field f-modal-auth-field-cell active" : "f-modal-auth-field f-modal-auth-field-cell "}>
          <p>Ingresa tu número celular para recuperar tu correo electrónico.</p>
          <TextField
            name={"cellPhone"}
            value={cellPhoneValue}
            onChange={e => {
              setCellPhoneValue(e.target.value);
              setCellPhonSend(false);
              setCellPhonSendError(null);
            }}
            type={"number"}
            placeholder={labelCellPhone}
            className="f-form-input"
            color="secondary"
            variant="outlined"
          />
          {cellPhoneSend && <span className="f-modal-auth-field-cell-answer">Hemos enviado tu correo electrónico al número celular.</span>}
          {cellPhoneSendError && <span className="f-modal-auth-field-cell-answer">{cellPhoneSendError}</span>}
          <button
            type="button"
            onClick={handleSendCellPhone}
            className="f-modal-auth-field-button"
          >
            ENVIAR
          </button>
        </div>
        <div className="f-modal-auth-footer">
          <button
            onClick={navigateToRegister}
            className="f-modal-auth-footer-button"
          >
            NO TENGO CUENTA Y ME QUIERO REGISTRAR
          </button>
        </div>
      </form>
    </LayoutModal>
  )
};

export default ModalAuth;